import collect, { Collection } from 'collect.js';
import MathHelpers from '../../services/utils/MathHelpers';

export type TipOption = {
  index: number;
  percentage: null | number;
  multiplier: null | number;
  is_zero?: boolean;
  is_custom?: boolean;
};

export default function useTips() {
  const options: Collection<TipOption> = collect([
    {
      index: 0,
      percentage: null,
      multiplier: null,
      is_zero: true,
    },
    {
      index: 1,
      percentage: 5,
      multiplier: 0.05,
    },
    {
      index: 2,
      percentage: 10,
      multiplier: 0.1,
    },
    {
      index: 3,
      percentage: 15,
      multiplier: 0.15,
    },
    {
      index: 4,
      percentage: null,
      multiplier: null,
      is_custom: true,
    },
  ]);

  const defaultOption: TipOption | null = options.firstWhere('is_zero');
  const customOption: TipOption = options.firstWhere('is_custom');

  const calculate = (amount: number, option?: TipOption): number => {
    if (!amount || !option?.percentage) {
      return 0;
    }

    return MathHelpers.roundNumberWithPrecision(amount * option.multiplier, 2);
  };

  return {
    options,
    defaultOption,
    customOption,
    calculate,
  };
}
